export const makeOrder = async (paymentData: any, token: string) => {
    const response = await fetch(
        'https://api-store-dev.appcharge.com/store/orders',
        {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}` // Add the Authorization header with the bearer token
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(paymentData) // body data type must match "Content-Type" header
        }
    );
    if (!response.ok) {
        console.log({ response });
        throw new Error('Failed to fetch');
    }
    return response.json();
};
